import styled from "styled-components";
import { TextBase } from "components";

export const Caption = styled(TextBase)`
  font-size: 0.75rem;
  line-height: 1.125rem;
`;